export default "__VITE_ASSET__Cc5TcySC__"